/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Layout related methods
 * -----------------------------------------------------------------------------
 *
 * @namespace layout
 */

import enquire from 'enquire.js';
import detectIt from 'detect-it';
import tinycolor from 'tinycolor2';
import Flickity from 'flickity';

var videoPlayer = null;

var layoutMethods = {
  data: function data() {
    return {
      scrollPosition: 0,
      isLogoLight: false,
      isOverlayVisible: false,
      isCartDrawerOpen: false,
      isMobileNavDrawerOpen: false,
      isSearchLayerOpen: false,
      isNewsletterPopupOpen: false
    };
  },


  methods: {
    _initLayout: function _initLayout() {
      window.addEventListener('scroll', app._checkScrollPos); // add scroll event listener
      window.addEventListener('resize', app._initStickyHeader); // add resize event listener

      // make all images in RTE editor load via lazyload
      $('.rte img').addClass('lazyload');

      app._initBootstrapComponents();
      app._initStickyHeader();
      app._initCarousels();
      app._checkScrollPos();
      app._checkCurrencyElements();

      // init videos
      if ($('.video-js').length > 0) {
        videojs(document.querySelector('.video-js'));
      }
    },
    _initBootstrapComponents: function _initBootstrapComponents() {
      /* Bootstrap components that need to be initialized should be called here */
      // init popover
      $('[data-toggle="popover"]').popover();

      // cart dropdown popover
      $('[data-cart-dropdown]').popover({
        html: true,
        content: function content() {
          return $(this).next('[data-cart-dropdown-content]').html();
        }
      });

      // init tooltip but only for desktop
      if (!detectIt.hasTouch) {
        setTimeout(function () {
          $('[data-toggle="tooltip"]').tooltip();
        }, 100);
      }
    },
    _initStickyHeader: function _initStickyHeader() {
      var $siteHeader = $(app.selectors.siteHeader);
      var $headerSlider = $(app.selectors.headerSlider);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var navHeight = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
      }

      if ($siteHeader.data('fixed-header')) {
        // boolean
        $('body:not(.template-index) #app').css('padding-top', navHeight);
      } else {
        $headerSlider.css('height', $headerSlider.outerHeight() - navHeight);
      }
    },


    /**
     * Window scroll info => update classes & elements
     */
    _checkScrollPos: function _checkScrollPos() {
      var $siteHeader = $(app.selectors.siteHeader);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var $navBgColor = $mainNav.css('backgroundColor');
      var isHeaderTransparent = $siteHeader.data('transparent-header');
      var isHomepage = $('body').hasClass('template-index');
      var windowScrollY = window.scrollY;
      var isDarkBg = void 0;
      var navHeight = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
      }

      if (app.scrollPosition < windowScrollY && app.scrollPosition > navHeight) {
        // direction down
        $('body').removeClass('is-scrolled-top is-scrolled-up').addClass('is-scrolled-down');
        isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

        if (isDarkBg) {
          app.isLogoLight = true;
        } else {
          app.isLogoLight = false;
        }
      } else {
        // direction up
        $('body').removeClass('is-scrolled-top is-scrolled-down').addClass('is-scrolled-up');
        if (isHomepage && isHeaderTransparent) {
          $mainNav.removeClass('bg-transparent');
        }
        isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

        if (isDarkBg) {
          app.isLogoLight = false;
        }
      }

      if (windowScrollY <= navHeight) {
        // reached top
        $('body').removeClass('is-scrolled-up').addClass('is-scrolled-top');

        if (isHomepage && isHeaderTransparent) {
          $mainNav.addClass('bg-transparent');
          app.isLogoLight = true;
        }
      }

      // hide popover past to 200
      // if (app.scrollPosition > 200){
      //   app.$root.$emit('bv::hide::popover')
      // }

      app.scrollPosition = windowScrollY;
    },
    _initCarousels: function _initCarousels() {
      var $carousel = $(app.selectors.carousel);
      var videoPlayerSlider = void 0;

      $carousel.each(function (index, el) {
        var flkty = Flickity.data(el); // pass in the element, $element[0], not the jQuery object

        if (typeof flkty === 'undefined') {
          return;
        }

        var totalSlides = flkty.cells.length;
        var selectedSlide = flkty.selectedElement;
        var slideType = $(selectedSlide).data('slide-type');

        if (totalSlides === 1) {
          $(el).addClass('hide-nav-ui');
        }

        flkty.on('settle', function () {
          selectedSlide = flkty.selectedElement;
          slideType = $(selectedSlide).data('slide-type');
          checkVideo(slideType);
        });

        flkty.on('change', function (index) {
          if (app.currentTemplate == 'product' && $('.youtube-video').length > 0) {
            $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          } else {
            if (videoPlayerSlider) {
              videoPlayerSlider.pause();
            }
          }
        });

        function checkVideo(slideType) {
          if (slideType !== 'video') return;
          if (app.currentTemplate == 'product' && $('.youtube-video').length > 0) {
            $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
          } else {
            videoPlayerSlider = videojs($(selectedSlide).find('.video-js')[0]);
            videoPlayerSlider.play();
          }
        }

        checkVideo(slideType);
        flkty.resize();
        app._triggerResize();
      });
    },
    _initVideo: function _initVideo(selectedSlide) {
      var $selectedVideo = $(selectedSlide).find('[data-video-slide]');
      var selectedVideoId = $selectedVideo.data('video-id');

      if (!selectedVideoId) {
        return;
      }

      function onPlayerReady(e) {
        e.target.setPlaybackQuality('hd720');
        e.target.mute();
        e.target.playVideo();
      }

      function onPlayerStateChange(e) {
        if (e.data === YT.PlayerState.ENDED) {
          // console.log('video finished');
        }
      }

      enquire.register('screen and (min-width: 720px)', {
        match: function match() {
          YouTubeIframeLoader.load(function (YT) {
            videoPlayer = new YT.Player($selectedVideo[0], {
              videoId: selectedVideoId,
              width: '100%',
              height: '100%',
              playerVars: {
                enablejsapi: 1,
                autoplay: 1,
                loop: 1,
                playlist: selectedVideoId, // otherwise loop will not work
                rel: 0,
                controls: 0,
                showinfo: 0,
                modestbranding: 0,
                disablekb: 1
                // 'start': 0,
                // 'end': 335,
              },
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange
              }
            });
          });
        },
        unmatch: function unmatch() {
          if (videoPlayer) {
            videoPlayer.destroy();
          }
        }
      });
    },


    /**
     * Event when variant quantity selector changes
     */
    _updateQty: function _updateQty(event) {
      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val();
      var $item = $(event.currentTarget).closest(app.selectors.cartItem);
      var variantId = $item.data('variant-id');
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var productCartLimit = $item.data('cart-limit');

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        // check if item has product limit assigned
        if (app.currentTemplate === 'cart' && app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }
      if (app.currentTemplate === 'account') {
        var variant = $('[name="delivery_frequency"]:checked').data('title');
        if (app.hasUpdateBoxCheck) {
          if (app.rechargeData.currentSubscription.quantity != qtyValue) {
            app.rechargeData.updateQty = qtyValue;
            app.hasUpdateBoxQty = true;
          } else {
            app.rechargeData.updateQty = qtyValue;
            app.hasUpdateBoxQty = false;
          }
        } else {
          app.rechargeData.updateQty = qtyValue;
          app.hasUpdateBoxQty = false;
        }
        app.updateProduct.selectedFreq = variant;
      } else {
        $qtyEl.val(qtyValue);
      }
    },


    /**
     * Event for toggling the cart drawer
     *
     */
    _toggleCartDrawer: function _toggleCartDrawer() {
      if (app.currentTemplate === 'cart') {
        return;
      }
      $('.cart-drawer .btn-close').trigger('focus');
      var $siteOverlay = $(app.selectors.siteOverlay);
      var cartType = $(app.selectors.siteHeader).data('cart-type');

      // stop parsing if cart type is not set to 'drawer'
      if (cartType !== 'cart_drawer') {
        return;
      }

      if (!app.isCartDrawerOpen) {
        // open drawer
        app.isOverlayVisible = true;
        app._lockScroll();

        // re-init tooltips but only for desktop
        if (!detectIt.hasTouch) {
          $('[data-toggle="tooltip"]').tooltip();
        }
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // toggle the status data
      app.isCartDrawerOpen = !app.isCartDrawerOpen;

      $siteOverlay.on('click', function () {
        if (app.isSearchLayerOpen) {
          return;
        }
        app._toggleCartDrawer();
        $('.nav-link[title="cart"]').trigger('focus');
      });

      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isCartDrawerOpen) {
          return;
        }
        e = e || window.event;
        if ($(e.target).attr('title') == "Close") {
          if (e.keyCode === 13) {
            app._toggleCartDrawer();
            $('.nav-link[title="cart"]').trigger('focus');
          }
        }
        if (e.keyCode === 27) {
          app._toggleCartDrawer();
          $('.nav-link[title="cart"]').trigger('focus');
        }
      });
    },


    /**
     * Event for toggling the mobile menu drawer
     *
     */
    _toggleMobileNavDrawer: function _toggleMobileNavDrawer() {
      var $siteOverlay = $(app.selectors.siteOverlay);
      $('.mobile-nav-drawer .btn-close').trigger('focus');
      if (!app.isMobileNavDrawerOpen) {
        // open drawer
        app.isOverlayVisible = true;
        app._lockScroll();
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // toggle the status data
      app.isMobileNavDrawerOpen = !app.isMobileNavDrawerOpen;

      $siteOverlay.on('click', function () {
        if (!app.isMobileNavDrawerOpen) {
          return;
        }
        app._toggleMobileNavDrawer();
      });
      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isMobileNavDrawerOpen) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27) {
          app._toggleMobileNavDrawer();
          $('.nav-link[title="menu"]').trigger('focus');
        }
      });
    },


    /**
     * Event for toggling the search layer
     *
     */
    _toggleSearch: function _toggleSearch() {
      var $searchLayer = $(app.selectors.searchLayer);
      var searchType = $searchLayer.data('search-type');
      var $inputSearch = $searchLayer.find('#searchInput');

      if (!app.isSearchLayerOpen) {
        $inputSearch.val('');
        app._lockScroll();

        if (searchType === 'full_screen') {
          $('header, footer, section').addClass('filter-blur').css('opacity', '0.5');
          $('[data-product-toolbar-mobile]').hide();
        } else {
          app.isOverlayVisible = true;
        }

        setTimeout(function () {
          $inputSearch.focus();
        }, 500);
      } else {
        $inputSearch.blur();
        app._unlockScroll();

        if (searchType === 'full_screen') {
          $('header, footer, section').removeClass('filter-blur').css('opacity', '1');
          $('[data-product-toolbar-mobile]').show();
        } else {
          app.isOverlayVisible = false;
        }
      }

      // toggle the status data
      app.isSearchLayerOpen = !app.isSearchLayerOpen;
      $('[data-site-overlay]').on('click', function () {
        if (app.isSearchLayerOpen) {
          app._toggleSearch();
        }
      });

      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isSearchLayerOpen) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27 && app.isSearchLayerOpen) {
          app._toggleSearch();
        }
      });
    },


    /**
     * Event for toggling the newsletter popup
     *
     */
    _toggleNewsletterPopup: function _toggleNewsletterPopup() {
      if (!app.isNewsletterPopupOpen) {
        app._lockScroll();
        app.isOverlayVisible = true;
      } else {
        app._unlockScroll();
        app.isOverlayVisible = false;
      }

      // toggle the status data
      app.isNewsletterPopupOpen = !app.isNewsletterPopupOpen;
    },


    /**
     * Lock window scroll
     *
     */
    _lockScroll: function _lockScroll() {
      $('html').css('overflow', 'hidden');

      $(document).on('touchmove', function (e) {
        if (!$(e.target).closest('[data-touch-moveable]').length) {
          e.preventDefault();
        }
      });
    },


    /**
     * Unlock window scroll
     *
     */
    _unlockScroll: function _unlockScroll() {
      $('html').css('overflow', 'auto');
      $(document).unbind('touchmove');
    },
    _changeCurrency: function _changeCurrency() {
      var $currencyForm = $('[data-currency-selector]');
      $currencyForm[0].submit();
    },


    /**
     * Recharge Integration => Attach Recharge widget dynamically
     */
    _attachRechargeWidget: function _attachRechargeWidget(productId) {
      // recharge widget
      var $subscriptionWidget = $("[data-recharge-subscription-widget=\"" + productId + "\"]");
      var $rcContainer = $("#recurring_choice_" + productId);
      if ($rcContainer.length > 0) {
        $subscriptionWidget.find('.inner').append($rcContainer);
        $subscriptionWidget.show();
        $rcContainer.show();
      }
      //app._changeRechargeDisplayPrices();
    },


    /**
     * Recharge Integration => Detach Recharge widget dynamically
     */
    _detachRechargeWidget: function _detachRechargeWidget(productId) {
      // recharge widget
      var $subscriptionWidget = $("[data-recharge-subscription-widget=\"" + productId + "\"]");
      var $rcContainer = $("#recurring_choice_" + productId);
      var $ghostPlaceholder = $('[data-recharge-ghost-placeholder]');

      if ($rcContainer.length > 0) {
        // reset recharge widget form to first options
        $('[data-input-one-time]').trigger('click');
        $subscriptionWidget.find('select').prop('selectedIndex', 0);
        // remove subscription properties
        $('[name="properties[subscription_id]"]').remove();
        // put back
        $ghostPlaceholder.append($rcContainer);
        $subscriptionWidget.find('.inner').empty();
        $subscriptionWidget.hide();
        $rcContainer.hide();
      }
    }
  }
};

export default layoutMethods;